/** @jsxImportSource @emotion/react */
import React from 'react'
import { Box, Button, useTheme } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { appLink } from '@app/config/appLink'
import { navButtonStyle } from './WorkspaceNavbar.styles'

type TabKey = 'create' | 'saved'

interface WorkspaceNavbarProps {
  currentTab: TabKey
}

const TABS: Array<{ key: TabKey; label: string; to: string }> = [
  { key: 'create', label: 'Create', to: appLink.riskWorkspacesCreate.path },
  { key: 'saved', label: 'Saved', to: appLink.riskWorkspaces.path },
]

export const WorkspaceNavbar: React.FC<WorkspaceNavbarProps> = ({ currentTab }) => {
  const theme = useTheme()

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 8,
        padding: '8px 0',
        backgroundColor: theme.palette.grey[50],
      }}
      role="tablist"
      onClick={(e) => e.stopPropagation()}
    >
      {TABS.map(({ key, label, to }) => {
        const isActive = currentTab === key

        return (
          <Button
            key={key}
            component={NavLink}
            to={to}
            onClick={(e) => e.stopPropagation()}
            role="tab"
            aria-selected={isActive}
            variant="contained"
            css={navButtonStyle(theme, isActive, 'light', 6)}
          >
            {label}
          </Button>
        )
      })}
    </Box>
  )
}
